import React, { useMemo } from 'react';
import useDataContext from 'data/context/data';

import { NAV_ITEMS } from '../specifications/lists';
import { Head, Layout } from '../components/layout';
import { ProductsSection } from '../components/custom/mainSections';

const ShopPage = () => {
  const dataContext = useDataContext();

  const [categories, products] = useMemo(
    () =>
      NAV_ITEMS.reduce(
        (acc, item) => {
          const category = dataContext.getCategory(item);
          if (category) {
            acc[0].push(category);
            return acc;
          }

          const product = dataContext.getProduct(item);
          if (product) {
            acc[1].push(product);
            return acc;
          }

          return acc;
        },
        [[], []],
      ),
    [dataContext],
  );

  return (
    <>
      <Head
        title="Shop Family History Books, Posters & Calendars"
        description="Browse every MyCanvas product. Family history books, photo books, wall art, calendars, magnets and prints made from your photos and family tree."
      />

      <Layout>
        {categories.map(category => (
          <React.Fragment key={category.id}>
            {category.data.map((item, index) => {
              let title = item.title;
              if (!title && index === 0) {
                title = category.name;
              }

              return (
                <ProductsSection
                  key={item.key}
                  title={title}
                  subCategories={item.subCategories}
                  products={item.products}
                  xs={12}
                  md={4}
                />
              );
            })}
          </React.Fragment>
        ))}
        {products.length > 0 && (
          <ProductsSection title="Other" products={products} xs={12} md={4} />
        )}
      </Layout>
    </>
  );
};

export default ShopPage;
